import script from "./directory.vue?vue&type=script&setup=true&lang=js"
export * from "./directory.vue?vue&type=script&setup=true&lang=js"

import "./directory.vue?vue&type=style&index=0&id=026c906a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026c906a"]])

export default __exports__